/*eslint-disable*/
import React, { useState } from 'react'
import {
    Button,
    Table,
    Th,
    Tr,
    Flex,
    PageWrapper,
    H1WithBack,
} from '../../styling/GlobalStyles'
import { NavBar } from '../../components/NavBar/NavBar'
import { InfoIcon } from 'assets/icons/InfoIcon'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { Options } from 'components/Options/Options'
import { setConfirmModal } from 'features/global/globalSlice'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Td } from 'components/Td/Td'
import { deleteTask, getTasks } from 'features/tasks/tasksSlice'
import { formatDateForDisplay, getParams } from 'utils/helpers'
import { taskStatusesData } from 'pages/Dashboard/dashboardData'
import useQueryPagination from 'hooks/useQueryPagination'
import CalendarInput from 'components/CalendarInput/CalendarInput'

export const Tasks = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const { noTasks, tasks } = useSelector((state: RootState) => state.tasks)
    const searchParams = new URLSearchParams(window.location.search);
    const [params, setParams] = useState<any>(getParams({
        location, ap: {
            date: new Date(searchParams.get('date') ?? new Date()).toISOString(),
        }
    }))

    useQueryPagination({ fetchFunctions: [getTasks], cleanUpFunctions: [], params })

    const handleDeleteTask = (id: number, type: 'task' | 'workflow') => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteTask({ id, type }))
                },
                word: 'delete task',
            }),
        )
    }

    const handleDate = (date) => {
        setParams({ date })
    }

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center mb='16' >
                    <H1WithBack title='Tasks Management' arrow link='/dashboard' />
                    <Flex gap='1rem' center >
                        <CalendarInput defaultValue={new Date(params.date) || new Date()} onChange={handleDate} />
                        <Button orange onClick={() => navigate('add')}>
                            Add Task
                        </Button>
                    </Flex>
                </Flex>
                {noTasks ? (
                    <NoItems title='Tasks' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='5%'></Td>
                            <Td w='10%' noTooltip text='Type' />
                            <Td w='25%' noTooltip text='Name' />
                            <Td w='17%' noTooltip text='Estimated start date' />
                            <Td w='17%' noTooltip text='Actual start date' />
                            <Td w='17%' noTooltip text='Status' />
                            <Td w='5%'></Td>
                        </Th>
                        {noTasks ? (
                            <NoItems title='Tasks' />
                        ) : (
                            tasks.map((item) => {

                                return (
                                    <Tr small key={item.workflow?.id ?? item.task.id}>
                                        <Td w='5%'><InfoIcon /></Td>
                                        <Td w='10%' noTooltip text={item.type == 'workflow' ? 'Workflow' : 'Task'} />
                                        <Td w='25%' noTooltip text={item.workflow?.name ?? item.task.name} />
                                        <Td w='17%' noTooltip text={formatDateForDisplay(item.workflow?.estimatedStartDate ?? item.task.estimatedStartDate)} />
                                        <Td w='17%' noTooltip text={(item.workflow?.actualStartDate || item.task?.actualStartDate) ? formatDateForDisplay(item.workflow?.actualStartDate ?? item.task.actualStartDate) : '/'} />
                                        <Td w='17%' noTooltip text={taskStatusesData[item.workflow?.status ?? item.task.status].name} />
                                        <Td options w='5%'>
                                            {!item.workflow && <Options
                                                item={item}
                                                handleRemove={() => handleDeleteTask(item.task ? item.task.id : item.workflow.id, item.task ? 'task' : 'workflow')}
                                                title='Tasks'
                                            />}
                                        </Td>
                                    </Tr>
                                )
                            })
                        )}
                    </Table>
                )}
            </PageWrapper>

        </>
    )
}
